'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
var Loader = require('../Loader/Loader.js');
require('./Input.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Input = function (props) {
    var id = props.id, type = props.type, onChange = props.onChange, error = props.error, inputMode = props.inputMode, className = props.className, readonly = props.readonly, placeholder = props.placeholder, name = props.name, maxLength = props.maxLength, minLength = props.minLength, min = props.min, pattern = props.pattern, disabled = props.disabled, size = props.size, isLoading = props.isLoading, loaderColor = props.loaderColor, isCurrency = props.isCurrency, defaultValue = props.defaultValue, isRequired = props.isRequired, onBlur = props.onBlur, onFocus = props.onFocus, value = props.value;
    var _a = React__default['default'].useState(false), shouldShowPassword = _a[0], setShowingPassword = _a[1];
    var showPasswordHandler = function () { return setShowingPassword(!shouldShowPassword); };
    var isNumericInput = function (event) {
        var key = event.keyCode || event.which;
        return ((key >= 48 && key <= 57) // Allow number line
            || (key >= 96 && key <= 105) // Allow number pad
        );
    };
    var isModifierKey = function (event) {
        var key = event.keyCode || event.which;
        return (event.shiftKey === true || key === 35 || key === 36) // Allow Shift, Home, End
            || (key === 8 || key === 9 || key === 13 || key === 46) // Allow Backspace, Tab, Enter, Delete
            || (key > 36 && key < 41) // Allow left, up, right, down
            || (
            // Allow Ctrl/Command + A,C,V,X,Z
            (event.ctrlKey === true || event.metaKey === true)
                && (key === 65 || key === 67 || key === 86 || key === 88 || key === 90));
    };
    var enforceFormat = function (event) {
        // Input must be of a valid number format or a modifier key
        if (!isNumericInput(event) && !isModifierKey(event)) {
            event.preventDefault();
        }
    };
    var formatMobileNumber = function (event) {
        if (isModifierKey(event)) {
            return;
        }
        var target = event.target;
        var input = target.value.replace(/\D/g, '').substring(0, 12); // First twelve digits of input only
        var areaCode = input.substring(0, 3);
        var middle = input.substring(3, 7);
        var last = input.substring(7, 11);
        var optional = input.substring(11, 12);
        if (input.length > 11) {
            target.value = areaCode + " " + middle + " " + last + " " + optional;
        }
        else if (input.length > 7) {
            target.value = areaCode + " " + middle + " " + last;
        }
        else if (input.length > 3) {
            target.value = areaCode + " " + middle;
        }
    };
    return (React__default['default'].createElement("div", { className: index['default']('lp__input--group', className && className) },
        React__default['default'].createElement("div", { className: index['default']('lp__input--wrapper', size && size, (disabled || isLoading) && 'disabled', error && 'lp__input--error') },
            type === 'tel' && (React__default['default'].createElement("span", { className: "input__prefix" }, isCurrency ? 'Rp' : '+62')),
            React__default['default'].createElement("input", { id: id, className: index['default']('lp__input', size && "lp__input--" + size), type: "" + (type === 'password' ? ("" + (shouldShowPassword ? 'text' : 'password')) : "" + type), onChange: onChange, placeholder: placeholder, inputMode: inputMode, readOnly: readonly, name: name, min: min, minLength: minLength, maxLength: (type === 'tel' && !isCurrency) ? 15 : maxLength, pattern: pattern, disabled: disabled, onKeyDown: function (event) {
                    if (type !== 'tel' || isCurrency)
                        return;
                    enforceFormat(event);
                }, onKeyUp: function (event) {
                    if (type !== 'tel' || isCurrency)
                        return;
                    formatMobileNumber(event);
                }, defaultValue: defaultValue, onBlur: onBlur, onFocus: onFocus, value: value }),
            React__default['default'].createElement("span", { className: index['default']('lp__input--label', isRequired && 'lp__input--required') }, placeholder),
            isLoading && (React__default['default'].createElement("span", { className: "lp__input--suffix" },
                React__default['default'].createElement(Loader.Loader, { loaderColor: loaderColor, spaceBtwText: "30px" }))),
            (type === 'password' || shouldShowPassword) && (React__default['default'].createElement("span", { className: "lp__input--suffix", onClick: showPasswordHandler },
                React__default['default'].createElement("i", { className: "" + (shouldShowPassword ? 'ion-md-eye' : 'ion-md-eye-off') }))),
            error && (React__default['default'].createElement("span", { className: "lp__input--suffix" },
                React__default['default'].createElement("i", { className: "ion-md-alert" })))),
        error && (React__default['default'].createElement("span", { className: "lp__help" }, error))));
};

exports.Input = Input;
//# sourceMappingURL=Input.js.map
